<div
  fxLayout="row"
  fxLayoutAlign="start center"
  [class.isDayNight]="isDayNight || isMensuel"
  *ngIf="!addVacationMode && !simpleOnOff"
>
  @if (options.length > 0) {
    <div
      class="toggle-container"
      [class.maximum-width]="isMensuel"
      [class.off]="isOff"
      [class.on]="isOn"
      [class.disabled]="disabled"
    >
      @for (option of options; track $index) {
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          [ngStyle]="{ 'width.%': equalColumnsWidth ? 100 / options.length : 'auto' }"
          (click)="optionClickHandler(option.value)"
          [ngClass]="{ current: actifOption === option.value, pointer: !disabled }"
          class="tab current"
          [class.light]="light && actifOption === option.value"
        >
          <mat-icon class="material-icons-outlined icon" *ngIf="option.icon">{{ option.icon }}</mat-icon>
          <p class="content">{{ option.label }}</p>
        </div>
      }
    </div>
  }

  <div *ngIf="label && label.length > 0" class="label">{{ label }}</div>
</div>

<div [class.isDayNight]="isDayNight || isMensuel" *ngIf="addVacationMode && !simpleOnOff">
  <div
    *ngIf="options.length > 0"
    [ngClass]="{ 'toggle-container-add-vacation-mode': addVacationMode, 'toggle-container': !addVacationMode }"
    class="toggle-container"
    [class.off]="isOff"
    [class.on]="isOn"
    [class.disabled]="disabled"
  >
    <div
      style="width: 50%"
      fxLayout="row"
      fxLayoutAlign="center center"
      [ngStyle]="{ 'width.%': equalColumnsWidth ? 100 / options.length : 'auto' }"
      (click)="optionClickHandler(option.value)"
      [ngClass]="{ current: actifOption === option.value, pointer: !disabled }"
      *ngFor="let option of options"
      class="tab current"
      [class.light]="light && actifOption === option.value"
    >
      <mat-icon class="material-icons-outlined icon" *ngIf="option.icon">{{ option.icon }}</mat-icon>
      <p class="content">{{ option.label }}</p>
    </div>
  </div>

  <div *ngIf="label && label.length > 0" class="label">{{ label }}</div>
</div>

<div fxLayout="row" fxLayoutAlign="center center" *ngIf="simpleOnOff">
  <div
    class="simple-toggle"
    (click)="optionClickHandlerSimple()"
    fxLayout="row"
    [fxLayoutAlign]="isOn ? 'end center' : 'start center'"
    [ngClass]="{ 'bg-on': isOn, 'bg-off': isOff }"
  >
    <span class="ball" [ngClass]="{ 'ball-on': isOn, 'ball-off': isOff }"></span>
  </div>
</div>
